
export interface IAgentState {

    getAllAgentsSuccess : any;
    getAllAgentsError : any;
    getAddAgentSuccess : any;
    getAddAgentError : any;
    getImportAgentSuccess : any;
    getImportAgentError : any;
    getEditAgentSuccess : any;
    getEditAgentError : any;
    getDownloadFileSuccess: any;
    getDownloadFileError: any;
    getAgentInactiveSuccess: any;
    getAgentInactiveError: any;
    getAgentactiveSuccess: any;
    getAgentactiveError: any;
    getAgentsBystatusIdSuccess : any;
    getAgentsBystatusIdError: any;
    
}

export const initialAgentState: IAgentState = {
    getAllAgentsSuccess : null, 
    getAllAgentsError : null, 
    getAddAgentSuccess : null, 
    getAddAgentError : null, 
    getImportAgentSuccess : null,
    getImportAgentError : null,
    getEditAgentSuccess : null, 
    getEditAgentError : null,
    getDownloadFileSuccess: null,
    getDownloadFileError: null,
    getAgentInactiveSuccess: null,
    getAgentInactiveError: null,
    getAgentactiveSuccess: null,
    getAgentactiveError: null,
    getAgentsBystatusIdSuccess : null,
    getAgentsBystatusIdError:null
}